import { useEffect, useState } from "react";

/**
 * Détecte si quelqu’un parle en analysant le volume de son stream audio.
 * @param {MediaStream} stream - Flux local ou distant
 * @param {number} threshold - Seuil de détection de la voix (ex: 0.05)
 */
export function useSpeakingDetector(stream, isMuted, threshold = 0.05) {
  const [isSpeaking, setIsSpeaking] = useState(false);

  useEffect(() => {
    if (!stream || isMuted) {
      setIsSpeaking(false);
      return;
    }
    const audioContext = new (window.AudioContext ||
      window.webkitAudioContext)();
    const source = audioContext.createMediaStreamSource(stream);
    const analyser = audioContext.createAnalyser();
    analyser.fftSize = 2048;
    const data = new Uint8Array(analyser.fftSize);

    source.connect(analyser);

    let speaking = false;
    let animationFrameId;

    const checkVolume = () => {
      analyser.getByteTimeDomainData(data);

      let sum = 0;
      for (let i = 0; i < data.length; i++) {
        const normalized = (data[i] - 128) / 128;
        sum += normalized * normalized;
      }

      const volume = Math.sqrt(sum / data.length);

      if (volume > threshold && !speaking) {
        setIsSpeaking(true);
        speaking = true;
      } else if (volume <= threshold && speaking) {
        setIsSpeaking(false);
        speaking = false;
      }

      animationFrameId = requestAnimationFrame(checkVolume);
    };

    checkVolume();

    return () => {
      cancelAnimationFrame(animationFrameId);
      source.disconnect();
      analyser.disconnect();
      audioContext.close();
    };
  }, [stream, threshold, isMuted]);

  return isSpeaking;
}
